import React from "react";
import WorkImg from "../assets/projects/workImg.jpeg";
import realEstate from "../assets/projects/realestate.jpg";

const Work = () => {
  return (
    <div
      name="work"
      className="w-full md:h-screen bg-[#0a192f] text-gray-300  "
    >
      {/* Container */}
      <div className=" max-w-[1000px] mx-auto  p-4 flex flex-col justify-center w-full  h-full   ">
        <div className=" pb-8  ">
          <p className="text-4xl font-bold inline border-b-4  border-pink-600 ">
            Work
          </p>
          <p className="py-6 ">// Check out some of my recent work</p>
        </div>
        {/* Container */}
        <div className=" grid sm:grid-cols2 md:grid-cols-3 gap-4 ">
          {/* Grid Item */}
          <div
            style={{ backgroundImage: ` url(${WorkImg})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                React JS Application
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{ backgroundImage: ` url(${realEstate})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                Neural Network
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a
                  href="https://github.com/stayhomewelldone/Neuralnetwork"
                  target="_blank"
                >
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>{" "}
          <div
            style={{ backgroundImage: ` url(${WorkImg})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                Decisiontree
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a
                  href="https://github.com/stayhomewelldone/Decisiontree"
                  target="_blank"
                >
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>{" "}
          <div
            style={{ backgroundImage: ` url(${realEstate})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                rockpaperscissorAI
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a
                  href="https://github.com/stayhomewelldone/rockpaperscissorAI"
                  target="_blank"
                >
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>{" "}
          <div
            style={{ backgroundImage: ` url(${WorkImg})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                MarvelAdventurer
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a
                  href="https://github.com/stayhomewelldone/MarvelAdventurer"
                  target="_blank"
                >
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>{" "}
          <div
            style={{ backgroundImage: ` url(${realEstate})` }}
            className=" shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div    "
          >
            {/* Hover Effects  */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className=" text-2xl font-bold text-white tracking-wider ">
                RestAPI
              </span>
              <div className="pt-8 text-center ">
                {/* <a href="/">
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg ">
                    Demo
                  </button>
                </a> */}
                <a
                  href="https://github.com/stayhomewelldone/RESTAPI"
                  target="_blank"
                >
                  <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
